// Send Emails
export const SEND_REMINDER_START = 'SEND_REMINDER_START';
export const SEND_REMINDER_FAILURE = 'SEND_REMINDER_FAILURE';
export const SEND_REMINDER_SUCCESS = 'SEND_REMINDER_SUCCESS';
export const RESET_SENT_EMAILS = 'RESET_SENT_EMAILS';
